// extracted by mini-css-extract-plugin
module.exports = {"dfv-container":"dfvAbbreviated_dfv-container__3QDcY","single-container":"dfvAbbreviated_single-container__1mf2G"};